import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { CardConfig } from '../../common/Cards/Settings/CardWithToggle/CardConfig';
import CardWithToggle from '../../common/Cards/Settings/CardWithToggle/CardWithToggle';
import { updateSlicedAlert, unsubscribeJobAlert } from '../../../actions/jobAlerts';
import { setNotification } from '../../../actions/appNotifications';
import { appNotificationsTypes } from '../../../utils/constants';

const EmailNotifications = (props) => {
  const { alertsActiveStatus, jobAlertList, cardStyleFade } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [slicedVal, setSlicedVal] = useState(2);

  const handleSlicedValChange = (newVal) => {
    setSlicedVal(newVal);
    dispatch(updateSlicedAlert(newVal));
  };

  const handleToggleChangeJobAlert = async (newToggleState) => {
    try {
      await dispatch(unsubscribeJobAlert(newToggleState));
      dispatch(
        setNotification({
          isAppStyled: true,
          message: `${
            newToggleState ? t('dashboard.settings.activejobalerts') : t('dashboard.settings.pausedjobalerts')
          }`,
          duration: 3000,
          type: appNotificationsTypes.SUCCESS
        })
      );
    } catch (err) {
      dispatch(
        setNotification({
          isAppStyled: true,
          message: `${err.message}`,
          duration: 3000,
          type: appNotificationsTypes.SUCCESS
        })
      );
    }
  };

  const cardConfig = CardConfig({
    t,
    jobAlerts: {
      status: alertsActiveStatus,
      data: jobAlertList,
      tooglerFunc: handleToggleChangeJobAlert,
      cardStyleFade
    },
    marketingInfo: { status: null, data: [], tooglerFunc: null },
    tneUpdates: { status: null, data: [], tooglerFunc: null }
  });

  return cardConfig.map(({ id, title, subtitle, details, extraComponent, status, dataList, tooglerFunc }) => {
    return (
      <CardWithToggle
        key={id}
        id={id}
        title={title}
        subtitle={subtitle}
        details={details}
        slicedVal={slicedVal}
        extraComponent={extraComponent}
        dataList={dataList}
        handleShowMoreClick={handleSlicedValChange}
        status={status}
        onToggleChange={tooglerFunc}
        cardStyleFade={cardStyleFade}
      />
    );
  });
};

export default EmailNotifications;
